import { render, staticRenderFns } from "./PayoutTable.vue?vue&type=template&id=054bfe56&scoped=true&"
import script from "./PayoutTable.vue?vue&type=script&lang=js&"
export * from "./PayoutTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054bfe56",
  null
  
)

export default component.exports